export default __webpack_public_path__ + "static/pop-ai-dark-14b1272b1c7c3c6cbf1684290d76a5bf8548aa2a9139eee15291f9e1f71998c8.png";